import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {documentsResourceType} from "../../documents-modal/configs/documents-model-config";
import {File} from "../../../../../features/pages/telegram-page/types/user-telegram.types";

@Injectable({
  providedIn: 'root'
})
export class FilesGenerateDocumentApiService {
  private http: HttpClient = inject(HttpClient);

  public generateTechTask(id: number): Observable<File> {
    return this.http.get<File>(`${baseUrl}/${documentsResourceType.path}/${id}/generate/task`);
  }

  public generateAct(id: number): Observable<File> {
    return this.http.get<File>(`${baseUrl}/${documentsResourceType.path}/${id}/generate/act`);
  }

  public generateContract(id: number): Observable<File> {
    return this.http.get<File>(`${baseUrl}/${documentsResourceType.path}/${id}/generate/contract`);
  }
}
